var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackProductEvent } from '@jetshop/core/analytics/tracking';
import { NostoElementContext } from '@jetshop/core/components/nosto/Element';
import useWarningInDev from '@jetshop/core/hooks/useWarningInDev';
import * as React from 'react';
import { Link } from 'react-router-dom';
function getPathWithTrailingSlash(path) {
    if (path.endsWith('/')) {
        return path;
    }
    else
        return path + '/';
}
const ProductLink = (_a) => {
    var { product, index, list, children, onClick, categoryPath } = _a, rest = __rest(_a, ["product", "index", "list", "children", "onClick", "categoryPath"]);
    const track = useTracker();
    const nostoAttribution = React.useContext(NostoElementContext);
    useWarningInDev(!product, `You must pass a product to ProductLink`);
    if (!product || !product.primaryRoute) {
        return React.createElement(React.Fragment, null, children ? children : product.name);
    }
    const { primaryRoute, id } = product;
    return (React.createElement(Link, Object.assign({}, rest, { onClick: event => {
            track(trackProductEvent({ action: 'click', product, list, index }));
            onClick && onClick(event);
        }, to: {
            pathname: categoryPath && primaryRoute
                ? getPathWithTrailingSlash(categoryPath.path) + primaryRoute.slug
                : /** Currently some products don't have a path or slug, so we can't link to them
                 * This is a bug in the API. For now, just route to '/'
                 * https://3.basecamp.com/3883449/buckets/5504968/messages/1205733128#__recording_1213985060
                 */
                    primaryRoute
                        ? primaryRoute.path
                        : '/',
            state: {
                type: 'Product',
                id
            },
            search: nostoAttribution && `?nosto=${nostoAttribution}`
        } }), children ? children : product.name));
};
export default ProductLink;
//# sourceMappingURL=ProductLink.js.map